import React, {useEffect} from "react"
import "./product-description-modal.scss"
import {createPortal} from "react-dom"
import { getLocalStorageValue } from "config/helper";

import ProductDescriptionTheme2 from "../../routes/product-description-theme2"
import {useSelector} from "react-redux"
import CateringProductDescription from 'routes/catering-product-description';
import useHideProductDescription from 'hooks/useHideProductDescriptionModal';

const Modal = () => {
  const theme = getLocalStorageValue("theme-name");
  const hideProductDescription = useHideProductDescription();
  const {modalProduct} = useSelector(({product}) => product)

  const isCatering = +modalProduct?.is_mealkit > 0;

  useEffect(() => {
    document.body.style.overflow = "hidden"

    const handleEscape = (e) => {
      if (document.querySelector('.product-full-image-overlay')) {
        return;
      }
      if (e.key === "Escape") {
        handleClose()
      }
    }

    document.addEventListener("keydown", handleEscape)

    return () => {
      document.body.style.overflow = "unset"
      document.removeEventListener("keydown", handleEscape)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClose = () => {
    hideProductDescription()
  }

  return (
    <>
    <div className={theme}>
      <div className="modal-backdrop">
        <div className="product-modal-popup">
        <div className="product-description-modal">
          <div className="top-btn">
          <button
          className="back-btn"
          onClick={handleClose}
          aria-label="modal"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1 1 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1 1 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23a1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2"/></svg>
          Back
        </button>
        <button
          className="product-description-modal-close"
          onClick={handleClose}
          aria-label="Close modal"
        >
          ×
        </button>
          </div>
          <div className="product-description-modal-body">
            {isCatering
             ? <div className="catering-modal"><CateringProductDescription modal /></div>
             : <ProductDescriptionTheme2 modal />}
          </div>
        </div>
      </div>
       </div>
    </div>
    </>
  )
}

const ProductDescriptionModal = () => {
  const {modalProduct} = useSelector(({product}) => product)

  if (!modalProduct) {
    return null
  }

  return <>{createPortal(<Modal />, document.body)}</>
}

export default ProductDescriptionModal
